<div class="d-flex flex-column">
  <div class="btn-group filters" *ngIf="activeFilters">
    <ng-container *ngFor="let filter of filterDefinitions">
      <ng-container *ngTemplateOutlet="multiSelect;context:filter">
      </ng-container>
    </ng-container>
    <div ngbDropdown class="btn-group" *ngIf="rangeFilter">
      <button ngbDropdownToggle [attr.data-btnId]="getElementId('dateFilter')" class="btn btn-sm btn-outline-primary">
        {{'Range' | translate}}: {{selectedFilters.date | translate}}
      </button>
      <div ngbDropdownMenu>
        <button class="dropdown-item" *ngFor="let filt of dateFilters"
                (click)="selectedFilters.date = filt; timeTravels('');">{{filt | translate}}
        </button>
      </div>
    </div>

    <!--VIVO HOMMA-->

    <div ngbDropdown class="btn-group" *ngIf="vivoFilters">
      <button ngbDropdownToggle class="btn btn-sm btn-outline-primary">
        {{'Tasktypes' | translate}}: {{selectedTask?.name | translate}}
      </button>
      <div ngbDropdownMenu class="results" style="max-height: 20em; overflow-y: auto;">
        <button class="dropdown-item" (click)="selectedTask.type = 'All'; selectedTask.template_id = ''; vivoTask()">
          {{'All' | translate}}
        </button>
        <button class="dropdown-item" *ngFor="let single of vivoTasks"
           (click)="selectedTask.type = single.name; selectedTask.template_id = single.value; vivoTask()">
          {{single.name | translate}}
        </button>
      </div>
    </div>

    <div ngbDropdown class="btn-group" *ngIf="vivoFilters">
      <button ngbDropdownToggle class="btn btn-sm btn-outline-primary">
        {{'Order by' | translate}}: {{vivoOrder.orderBy | translate}}
      </button>
      <div ngbDropdownMenu class="results">
        <button class="dropdown-item" *ngFor="let single of ['updatedAt', 'createdAt']"
                (click)="vivoOrder.orderBy = single; vivoTask()">
          {{single | translate}}
        </button>
      </div>
    </div>

    <div ngbDropdown class="btn-group" *ngIf="vivoFilters">
      <button ngbDropdownToggle class="btn btn-sm btn-outline-primary">
        {{'Reverse order' | translate}}: {{vivoOrder.reverse.toString() | translate}}
      </button>
      <div ngbDropdownMenu class="results">
        <button class="dropdown-item" (click)="vivoOrder.reverse = true; vivoOrderBy()">
          {{'True' | translate}}
        </button>
        <button class="dropdown-item" (click)="vivoOrder.reverse = false; vivoOrderBy()">
          {{'False' | translate}}
        </button>
      </div>
    </div>

    <!--VIVO HOMMA-->

    <div ngbDropdown class="btn-group" *ngIf="typeFilter">
      <button ngbDropdownToggle [attr.data-btnId]="getElementId('typeFilter')" class="btn btn-sm btn-outline-primary">
        {{'Type' | translate}}: {{selectedFilters.type | translate}}
      </button>
      <div ngbDropdownMenu>
        <button class="dropdown-item" *ngFor="let event of eventType"
                (click)="selectedFilters.type = event; timeTravels('');">{{event | translate}}
        </button>
      </div>
    </div>
  </div>
  <div class="active-filters" *ngIf="!alwaysActive">
    <a (click)="activeFilters = !activeFilters">
      {{'Filters' | translate}}
    </a>
  </div>
</div>

<div class="arrow-buttons" *ngIf="selectedFilters.date !== 'All'">
  <div class="date-button">
    <a class="link" style="margin: auto;" (click)="timeTravels('previous')">
      <svg class="svg-inline--fa fa-w-20">
        <use xlink:href="#left"></use>
      </svg>
    </a>
  </div>
  <div class="date-field" *ngIf="startDate">
    <span>{{startDate | date: 'dd.MM.yyyy'}} - {{endDate |  date: 'dd.MM.yyyy'}}</span>
  </div>
  <div class="date-button">
    <a class="link" style="margin: auto;" (click)="timeTravels('next')">
      <svg class="svg-inline--fa fa-w-20">
        <use xlink:href="#right"></use>
      </svg>
    </a>
  </div>
</div>

<ng-template #multiSelect let-name="name" let-filterValues="filterValues">
  <div ngbDropdown class="btn-group">
    <button ngbDropdownToggle [attr.data-btnId]="getElementId('name')" class="btn btn-sm btn-outline-primary">
      {{name | translate}}: {{getActiveFilterCount(filterValues)}}
    </button>
    <div ngbDropdownMenu>
      <button *ngFor="let item of filterValues"
              class="dropdown-item d-flex justify-content-between align-items-center"
              (click)="item.active = !item.active; selectedFilterChanged()">
        <span *ngIf="item.active; else inactive" class="active-dot"></span>
        <span>
        {{item.description}}
      </span>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #inactive>
  <span class="inactive-dot"></span>
</ng-template>

<i class="fas fa-arrow-left" data-fa-symbol="left"></i>
<i class="fas fa-arrow-right" data-fa-symbol="right"></i>
